declare const window: Window & { dataLayer: Record<string, unknown>[] }

type BaseFormOptions = {
  formStepName: string
  formStepIndex: number | string
  previousFormStepName?: string
  email?: string
  doctor?: string
  clinic?: string
  consultationType?: string
  loadTime?: number
}

type FormErrorOptions = {
  error?: string
}

type FormInteractionOptions = {
  action?: 'click' | 'open' | 'close' | 'next' | 'previous'
  formFieldName?: string
  formFieldValue?: string
  formFieldValues?: string[]
}

type FormOptions = BaseFormOptions & FormErrorOptions & FormInteractionOptions

const trackEvent = (event: string, options: FormOptions) => {
  const {
    action,
    clinic = '',
    consultationType = '',
    doctor = '',
    email = '',
    error,
    formFieldName,
    formFieldValue,
    formFieldValues,
    formStepIndex,
    formStepName,
    loadTime,
    previousFormStepName,
  } = options

  const eventData = {
    event,
    form_name: `initial_booking_flow_${import.meta.env.THEME}`,
    interaction_type: action,
    tm_clinic: clinic,
    tm_consult: consultationType,
    tm_doctor: doctor,
    tm_email: email,
    tm_field_name: formFieldName,
    tm_index: formStepIndex,
    tm_load_time: loadTime,
    tm_name: formStepName,
    tm_prev_name: previousFormStepName,
    tm_type: error,
    tm_value: formFieldValue,
    tm_value_list: formFieldValues?.join(','),
  }

  window.dataLayer.push(eventData)
}

export const formStart = ({
  formStepIndex,
  formStepName,
  loadTime,
}: FormOptions) => {
  trackEvent('form_start', {
    formStepIndex,
    formStepName,
    loadTime,
  })
}

export const formProgress = (eventProps: FormOptions) => {
  trackEvent('form_progress', eventProps)
}

export const formInteraction = (
  eventProps: BaseFormOptions & FormInteractionOptions,
) => {
  trackEvent('form_interaction', eventProps)
}

export const formError = (eventProps: BaseFormOptions & FormErrorOptions) => {
  trackEvent('form_error', eventProps)
}

export const formComplete = (eventProps: FormOptions) => {
  trackEvent('form_complete', eventProps)
}
